import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectUser } from "UserAuthorized/selectors/securitySelector";
import { securityGetUser } from "UserAuthorized/actions/security";
import UserAuthorized from "UserAuthorized";

const mapStateToProps = state => {
  return {
    userInfo: selectUser(state)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    securityGetUser: () => dispatch(securityGetUser())
  };
};
class UserAuthorizedContainer extends React.Component {
  static propTypes = {
    userInfo: PropTypes.object,
    securityGetUser: PropTypes.func,
    errors: PropTypes.array
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.init();
  }
  init = () => {
    this.props.securityGetUser();
  };
  render() {
    const { userInfo } = this.props;
    return (
      <React.Fragment>
        <UserAuthorized userInfo={userInfo} />
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAuthorizedContainer);
